import React, {Component} from 'react';
import _ from 'lodash';
import Loading from "../../loading";

class ConagoModal extends Component {
	render() {
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione las metas que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.conagoClauses.isFetching ? <Loading message="Cargando Metas CONAGO..."/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.conagoClauses.conago.map((conago, k) => {
										let shouldCheck = _.findKey(this.props.selectedConago, {id: conago.id}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`conago-${conago.id}`} className="checkbox">
													<input id={`conago-${conago.id}`} ref={`g-conago-${conago.id}`}
													       value={conago.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveConago(conago.id)}/>
													{conago.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveConago(conago) {
		if (this.refs[`g-conago-${conago}`].checked) {
			this.props.add(`projects.edit.conago_clauses`, _.find(this.props.conagoClauses.conago, {id: conago}));
		} else {
			let conagoKey = _.findIndex(this.props.selectedConago, {id: conago});
			this.props.remove(`projects.edit.conago_clauses`, conagoKey);
		}
	}
}

/*class ConagoModal2 extends Component {
	render() {
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background"/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Seleccione las metas que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							{this.props.conagoClauses.isFetching ? <Loading message="Cargando Metas CONAGO..."/> :
								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{this.props.conagoClauses.conago.map((conago, k) => {
										let shouldCheck = _.findKey(this.props.selectedConago, {id: conago.id}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`conago-${conago.id}`} className="checkbox">
													<input id={`conago-${conago.id}`} ref={`g-conago-${conago.id}`}
													       value={conago.id} type="checkbox" checked={shouldCheck}
													       className="checkbox"
													       onChange={() => this._saveConago(conago.id)}/>
													{conago.name}
												</label>
											</div>
										);
									})}
								</div>
							}

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_saveConago(conago) {
		if (this.refs[`g-conago-${conago}`].checked) {
			this.props.add(`projects.goals[${this.props.selectedGoal}].conago_clauses`, _.find(this.props.conagoClauses.conago, {id: conago}));
		} else {
			let conagoKey = _.findIndex(this.props.selectedConago, {id: conago});
			this.props.remove(`projects.goals[${this.props.selectedGoal}].conago_clauses`, conagoKey);
		}
	}
}*/

export default ConagoModal;


// WEBPACK FOOTER //
// ./src/elements/projects/widgets/conago-modal.jsx